import { createAsyncThunk } from "@reduxjs/toolkit";
import usageService from "../../services/usageService";

export const getMongoUsageThunk = createAsyncThunk(
  "usage/getMongoUsage",
  async (_, { rejectWithValue }) => {
    try {
      const response = await usageService.getMongoUsage();
      return { usage: response.usage, limits: response.limits };
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const getMediaUsageThunk = createAsyncThunk(
  "usage/getMediaUsage",
  async (_, { rejectWithValue }) => {
    try {
      const response = await usageService.getMediaUsage();
      return { usage: response.usage, limits: response.limits };
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const getTwilioUsageThunk = createAsyncThunk(
  "usage/getTwilioUsage",
  async (_, { rejectWithValue }) => {
    try {
      const response = await usageService.getTwilioUsage();
      return {
        usage: response.usage,
        limits: response.limits,
        enabled: response.enabled,
      };
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);
